import { Box, CircularProgress, Modal } from "@mui/material";
import { useState } from "react";
import Styles from './style.module.css';
// import { setUserData } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import Toastify from "../container/helper/Toastify";
import api from "../container/helper/Api";
import { setLogin } from "../container/redux/userSlice";
import { setRegister } from "../container/redux/registerStudentSlice";
import { useNavigate } from "react-router-dom";

const AffiliateRegistrationModal = ({ closeModal, open, desc, data, setShowModal }) => {
    const navigate = useNavigate()
    const [otp, setOtp] = useState("");
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)

    const Data = data


    const styles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "white",
        border: "none",
        padding: "27px 0px",
        height: "fit-content",
        display: "block",
        width: '600px',
        borderRadius: '7px',
        "&:focus": {
            outline: "none",
        },
    };

    const handleSubmit = async () => {
        if (otp.length === 4) {

            try {
                setIsLoading(true)
                const { data, status } = await api.verifyAffiliateUser({ otp: otp, ...Data })

                if (status === 200) {
                    Toastify.success("Otp verified successfully");
                    setOtp("")
                    closeModal()
                    setShowModal(true)
                }
            } catch (error) {
                setOtp("")
                console.log("errorirjej", error)
                Toastify.error(error.response.data.message || `something went wrong`);
                // closeModal()
            }
            finally {
                setIsLoading(false)
            }
        } else {
            console.log("not clicked");
        }


    };

    // const handleSubmit=async()=>{
    //   console.log("hy");

    // }

    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styles}>
                <div
                    className={Styles.entryView}
                    style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                        flexDirection: "column",
                    }}
                >
                    <div className={Styles.headingText} style={{ textAlign: "center" }}>
                        Enter Your OTP
                    </div>

                    <div className={Styles.lineStyle} style={{ width: "100%" }} />
                    {desc && (

                        <div className={Styles.descStyle}>
                            {/* We have sent you an OTP to your vy***@gmail.com, please check and verify. */}
                            {desc}

                        </div>
                    )}

                    <input
                        type="text"
                        placeholder="Enter 4-digit OTP..."
                        value={otp}
                        onChange={(e) => {
                            const input = e.target.value;
                            if (/^\d{0,4}$/.test(input)) setOtp(input); // Only allows up to 4 digits
                        }}
                        className={Styles.otpInput}
                    />

                    <div className={Styles.buttons}>
                        <div onClick={closeModal} className={Styles.cancelStyle} style={{ cursor: "pointer" }}>
                            Cancel
                        </div>
                        {/* <div
            //   onClick={otp.length === 4 ? handleSubmit : null}
             onClick={() => {
                handleSubmit();
              }}
              className={`${Styles.deleteStyle} ${
                otp.length !== 4 ? Styles.disabled : ""
              }`}
              style={{
                cursor: otp.length === 4 ? "pointer" : "not-allowed",
                opacity: otp.length === 4 ? 1 : 0.6,
              }}
            > */}
                        <div
                            onClick={() => {
                                handleSubmit();
                            }}
                            className={`${Styles.deleteStyle}`}
                            style={{
                                cursor: otp.length === 4 ? "pointer" : "not-allowed",
                                opacity: otp.length === 4 ? 1 : 0.6,
                            }}
                        >
                            {isLoading ? <CircularProgress size="22px" color="inherit" /> : `Submit`}
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default AffiliateRegistrationModal 
